import * as React from 'react';
import { IGeneralSettings } from '../models/generalSettingsModel';
import { IMapConfiguration } from '../models/mapConfigurationModel';
import { ConfigurationCtxProvider, testServerUrlProps } from './ConfigurationContext';

export function ConfigurationProvider({
  children,
  generalSettings,
  mapConfiguration,
  getLocatorSuggestions,
  getProxyUrl,
  testServerUrl
}: {
  children: React.ReactNode;
  generalSettings: IGeneralSettings;
  mapConfiguration: IMapConfiguration;
  getLocatorSuggestions: (request: string) => Promise<any>;
  getProxyUrl: () => string;
  testServerUrl: (server: testServerUrlProps, tenantId?: string) => Promise<void>;
}) {
  return (
    <ConfigurationCtxProvider
      value={{ generalSettings, mapConfiguration, getLocatorSuggestions, getProxyUrl, testServerUrl }}
    >
      {children}
    </ConfigurationCtxProvider>
  );
}
